import React,{useEffect} from 'react'
import {connect} from "react-redux";
import{bindActionCreators} from "redux";
import ReactHtmlParser from 'html-react-parser';
import {ReactComponent as CloseIcon} from "../../../design-system/design_system/assets/icons/components/notifications/close.svg";
import{menuOverlay,setScreenWidth,headerNavigation} from "../../actions/HeaderActions";
const Notification = (props) => {
    const{showOverlay,notificationData, screenWidth, handleNotificationFunc} = props;
    const {REACT_APP_IMAGEURL} = window.weeksWebCloudConfig
   // console.log(props);
    useEffect(() => {
    }, [props])
        return (
            <div className="notification-container bg-white">
               
                    <div className="py-3 px-5 d-none d-lg-block">
                    <span className="font-weight-bolder">{notificationData.HeadingText}</span>
                    <button className="float-right" title="" 
                    onClick={handleNotificationFunc}>
                        <CloseIcon width="24px" height="24px"/>
                    </button>
                </div>
                
               <AlertMessage alertData={notificationData} imageUrl={REACT_APP_IMAGEURL}/>
            </div>
        )
}
const mapStateToProps =(state) =>{
    return{
        showOverlay:state.CommonReducer.showOverlay,
        showMobileOverlay:state.CommonReducer.showMobileOverlay,
        screenWidth:state.CommonReducer.screenWidth,
        notificationData: state.CommonReducer.notification
    }
    
}


const mapDispatchToProps = (dispatch) =>bindActionCreators({
    menuOverlayfunc: menuOverlay,
    setScreenWidthFunc:setScreenWidth,
    setHeaderNav:headerNavigation,
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Notification)

const AlertMessage = ({alertData, imageUrl}) =>{
    if(alertData !== undefined){
        if(alertData.Alert !== undefined && alertData.Alert.length > 0){
            return(
                <ul className="notification-messages">
                {alertData.Alert.map((data, indexKey)=>
                <li className="message" key={indexKey}>
                    <img src={imageUrl+data.AlertIcon} alt="" 
                    className="icon"
                    />
                    <span className="mt-2">{ReactHtmlParser(data.Description)}</span>
                </li>)}
                
            </ul>
            )
        }
        else{
            return<ul><li className="py-3 px-5">{alertData.ZeroAlertText}</li></ul> 
        }
        
    }
    else{
       return null;
    }
   
}